import { matchTrackKind } from '@anytracker/core'

import { BooleanInput } from './BooleanInput.js'
import { EnumInput } from './EnumInput.js'
import { NumericInput } from './NumericInput.js'
import type { ValueInputProps } from './types.js'

/**
 * Renders the right control for any track.
 *
 * This is the **only** place in the app that branches on track kind for input.
 * T-304's entry form renders `<ValueInput track={track} … />` for every track
 * in a check-in and never asks what kind any of them is — which is what stops
 * a fourth kind meaning edits scattered across every screen that collects a
 * value.
 *
 * `matchTrackKind` rather than a `switch`: adding a kind to core turns this
 * into a compile error here, at the single place that has to change.
 *
 * `variant` rides along untouched. The full-screen controls the log flow uses
 * are the same components at a different size (T-806), not a second set — so
 * this stays the only kind-branch for input, and there is one place where
 * "re-pressing clears the value" is implemented.
 */
export function ValueInput(props: ValueInputProps) {
  return matchTrackKind(props.track.kind, {
    numeric: (kind) => <NumericInput {...props} kind={kind} />,
    boolean: (kind) => <BooleanInput {...props} kind={kind} />,
    enum: (kind) => <EnumInput {...props} kind={kind} />,
  })
}
